import createPalette from '@material-ui/core/styles/createPalette';

const palette = createPalette({
  common: {
    black: '#000',
    white: '#fff',
  },
  background: {
    paper: '#FEFAF5',
    default: '#FEFAF5',
  },
  primary: {
    main: '#6140FF',
    light: '#AC70FF',
  },
  text: {
    primary: '#000',
  },
  error: {
    main: '#EF4445',
  },
  // custom colors
  lightOrange: '#FFB258',
  spBackground: '#FFF8ED',
  lightGray: '#FEFAF5',
  haiti: '#100B2B',
  bianca: '#FCF8F2',
  dolphin: '#666174',
  silver: '#C4C4C4',
  pampas: '#EAE6E1',
  oldLace: '#FEFAF5',
  electricViolet: '#6633FF',
  naturalGray: '#8C8B8A',
  emerald: '#52D869',
  silverbd: '#BDBDBD',
  gray: '#888888',
  haitiTemplate: '#080820',
  manatee: '#908F96',
  chicago: '#605F5D',
  jumbo: '#88868F',
  hotCinnamon: '#E0501B',
  steelGray: '#232333',
  swissCoffee: '#DBD8D6',
  paleSlate: '#B8B5B7',
  moonRaker: '#E6DDF7',
  electricVioletG: '#6647FF',
  dolphina: '#6A677A',
  outrageousOrange: '#FF5833',
  whisper: '#F1EBF6',
  swissGray: '#dbd8d6a3',
  selectiveYellow: '#FFBC00',
  sunglow: '#FFCB33',
  springWood: '#F5F1ED',
  eveningSea: '#033C3D',
  whisperBanner: '#F5F5F9',
  purpleHeart: '#563ADA',
  tiber: '#072F30',
  friarGray: '#84827F',
  bridalHeath: '#FFFAF5',
  naturalGray2: '#85827F',
  dodgerBlue: '#408CFF',
  mineShaft: '#222222',
  chicagoV2: '#5C5A58',
  springWood2: '#F4F0EB',
  salomie: '#FFDF8D',
  orangeRoughy: '#CC4321',
  merino: '#F9F5F0',
  doveGray: '#5C5C5C',
  peachYellow: '#FADDA5',
  mineShaft2: '#424242',
  caribbeanGreen: '#00CC88',
  lightSendsparkPurple: '#6140ff14',
  opacityMainPurple: '#F9F4F8',
  outrageousOrange2: '#FF623E',
  persimmon: '#FF6F4D',
  electricViolet3: '#6E4FFF',
  valhalla: '#211752',
  codGray: '#111111',
  royalBlue: '#4D2CEB',
  codGray2: '#121212',
  lightBlue: '#E4F4F4',
  bridalHeath2: '#FFFCF8',
  hintofGreen: '#E6FFE6',
  champagne: '#FBEDD3',
  westar: '#E6E3DE',
  masala: '#444444',
  isabelline: '#F9F3ED',
  majorelleBlue: '#7747D8',
});

export default palette;
